module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18326/js/img/valuePropModals/FormConditionalLogic/ValueProp2.svg"